module.exports = __webpack_public_path__ + "img/Mamahauskreis.8f671ab4.jpg";